import { useState } from "react";
import NavigationBar from "../../../components/navbar/NavigationBar";
import PageTitle from "../../../components/Page Title/PageTitle";
import discordLogo from '../../../assets/icons/discord-logo.png';
import "./Info.css";
//TODO: FAQ is too wide, will need changes... eventually
const faqItems = [
  {
    question: "What is this?",
    answer: (
      <>
        <p>
          HnG Revival is a community-driven project to bring Heroes and Generals back to life because we genuinely love the game.
          The devs are a group of passionate people who were dedicated enough to get through all the reverse engineering challenges.game connects to our own custom servers made from scratch. It’s been a real challenge, but over the past months more and more of the game became functional.
        </p>
      </>
    )
  },
  {
    question: "Is there a community?",
        answer: (
      <>
        <p>
          If you're looking to connect with other players, share feedback, or just hang out, there's an active Discord server called HeroesandgeneralsBeta — it's the main hub for the Revival community with over 25k members. here’s also the original Heroes & Generals subreddit, which is still kicking. We’re building this community together, so come say hi — you’re more than welcome.
        </p>
      <div class="discord-container">
        <img class="discordlogo" src={discordLogo} alt="discord logo" />
        <a href="https://discord.gg/heroesandgeneralsbeta" target="_blank" rel="noopener noreferrer" class="join-discord">
          Join Our Server
        </a>
      </div>
      </>
    )
  },
  {
    question: "Is it ready?",
    answer: (
      <>
        <p>
          As of April 2026, it is not ready yet, we just implemented the long awaited Easy-Anti-Cheat, and upgraded servers to a high (60) tickrate, which are both quite destructive changes that created a lot of bugs. While there is no official ETA, we do hope to finally get it out this year.
        </p>
      </>
    )
  },
  {
    question: "Can I help?",
    answer: (
      <>
        <p>
          The best way you can support us is simple: just play the game. Keeping the servers active and the community alive helps us more than you might think.
          <br/>If you run into bugs or strange issues, let us know. We can’t fix everything (especially stuff baked into the original game client), but we’ll do our best to get it sorted. Your feedback is super valuable. <br /> <br />
          If you feel like going the extra mile, we have a <a href="https://www.patreon.com/hnggroup" target="_blank" rel="noopener noreferrer">Patreon page</a>. These donations help cover server costs and keep us caffeinated during long debugging sessions. We’re keeping things fair and community-first. <br/>Thanks for being part of this. It means a lot. ❤️
        </p>
      </>
    )
  },
  {
    question: "Can I use my old account?",
    answer: (
      <>
        <p>
          We don’t have access to the original game’s servers or data, old accounts and progress are gone.. You have to create a new account in order to play.
        </p>
      </>
    )
  },
  {
    question: "Will there be new content?",
    answer: (
      <>
        <p>
          We are working on new content and features that will be added to the game over time. The priority is to get the original game fully functional and stable, and fix some clear issues, but we either already have or are working on tools, including a <b> map editor</b>, RTS editor, tools that will allow us rebalance weapons, possibly new skins, and maybe even weapons.
        </p>
      </>
    )
  },
  {
    question: "Grind and Progression",
    answer: (
      <>
        <p>
          No account starts with everything, just like in the original, you need to play and progress, to unlock weapons, vehicles and badges. We have a lot of the original progression system in place, but we’re also working on some new features and improvements to make the grind more rewarding and fun.
        </p>
      </>
    )
  },
  {
    question: "Servers & Performance",
    answer: (
      <>
        <p>
          We are hosting good quality dedicated servers all over the globe, current regions include Canada, Central Europe and Singapore. We are paying out of our own pocket, so if you are really lacking a server in your region, you need to fund it yourself, or as a group.
        </p>
      </>
    )
  },
  {
    question: "I need help",
    answer: (
      <>
        <p>
          We have a team of support staff ready to help out with your issues. Raise a ticket on the discord and wait for the response. We will do our best to help you out as soon as possible, but remember the work is volunteer based and we have a life outside of this project.
        </p>
      </>
    )
  }
];

function FAQItem({ question, answer }) {
  const [open, setOpen] = useState(false);

return (
  <div className={`faq-item ${open ? "open" : ""}`}>
    <button
      className="faq-question"
      onClick={() => setOpen(!open)}
    >
      <span>{question}</span>
      <span className={`faq-arrow ${open ? "open" : ""}`}>▶</span>
    </button>

    <div className="faq-answer">
      {open && answer}
    </div>

  </div>
);
}

const Info = () => {
  return (
    <div>
      <NavigationBar />
      <PageTitle title="Frequently Asked Questions" />
      <div className="pagebox">
        <div className="faq-container">
          {faqItems.map((item, index) => (
            <FAQItem key={index} {...item} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default Info;